export default (function (payload) {
    if (payload) {
        var value = payload.replace(/[^0-9\d\.]+/g, '');
        var valid = /^\d+(\.\d*)?$/.test(value);
        if (valid) {
            return value;
        }
    }
    return '';
});
